import React from "react";
import { useSearchParams } from "react-router-dom";

const LandingPageViewProxy: React.FC = () => {
  const [searchParams] = useSearchParams();
  const pageId = searchParams.get("page_id");
  const formId = searchParams.get("form_id");

  const baseUrl =
    process.env.REACT_APP_FIREBASE_FUNCTION_BASE_URL ||
    "https://asia-south1-bench-dev-93520.cloudfunctions.net";

  let url = `${baseUrl}/pageHtml?page_id=${pageId}`;
  if (formId) url += `&form_id=${formId}`;

  return (
    <iframe
      src={url}
      style={{
        width: "100vw",
        height: "100vh",
        border: "none",
        display: "block",
      }}
      title="Landing Page"
    />
  );
};

export default LandingPageViewProxy;
